import RenderFormForModal from "@/components/Form/Renderer/RenderFormForModal";
import { FormUIContext } from "@/context";
import { fetchEmployeeInfo, updateEmployee } from "@/services/employee.services";
import { EditEmployeeConfig } from "@/utils/constant/formConfig.constant";
import { toastErrorMessage, toastMessage } from "@/utils/helper/myToast";
import { filterTruthyValues } from "@/utils/helper/string";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FormSkeleton } from "@/common/ui/Loader";
import { useAppDispatch } from "@/store/store";
import { setPageEvent } from "@/store/features/dashboardSlice";

interface EditEmployeeProps {
  onClose: (props?: any) => void;
  afterCall?: any;
}

const EditEmployee: React.FC<EditEmployeeProps> = ({ onClose, afterCall }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultFormData, setDefaultFormData] = useState<any>(null);
  const { employeeId } = useParams();
  const dispatch = useAppDispatch();

  const handleFormSubmit = async (formData: any) => {
    const empData = defaultFormData?.data || {};
    const res: any = await updateEmployee(filterTruthyValues({ empExtId: empData.empExtId, ...formData }));
    if (res?.status === 200) {
      const { message, isError } = res.data;
      if (defaultFormData?.afterCall) {
        defaultFormData.afterCall();
      }
      dispatch(setPageEvent({ keys: ["Overview", "Employee details", "activities"], type: "refresh" }));
      setTimeout(() => {
        dispatch(setPageEvent(null));
      }, 5000);
      onClose({ disabledWarning: true });
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const res = await fetchEmployeeInfo({ empId: employeeId, view_typ: "employee-details" });
        if (res) {
          setDefaultFormData({ data: res, afterCall });
        } else {
          return toastErrorMessage("failed to load data");
        }
      } catch (err) {
        console.error("Failed to fetch employee info", err);
      } finally {
        setIsLoading(false);
      }
    };
    if (!defaultFormData) {
      if (employeeId) {
        loadData();
      }
    }
  }, [employeeId]);

  if (isLoading) {
    return <FormSkeleton />;
  }

  const isAccountOwnerRole = (defaultFormData?.data as any)?.userTyp?.label === "Account Owner";

  if (!defaultFormData) return null;
  return (
    <FormUIContext.Provider value={{ isFormLoading, setIsFormLoading }}>
      <RenderFormForModal
        handleFormSubmit={handleFormSubmit}
        handleCancel={onClose}
        formConfig={{
          ...EditEmployeeConfig,
          sections: EditEmployeeConfig.sections.map((section) => ({
            ...section,
            widgets: section.widgets.filter((widget) => {
              if (widget.field === "reportingManager") {
                return !isAccountOwnerRole;
              }
              return true;
            }),
          })),
        }}
        defaultValues={defaultFormData.data}
        className="p-4 overflow-y-auto h-[calc(100%-30px)]"
        formClassName=""
        btnContainerClass=" sticky bottom-0 bg-white py-5 pr-5"
      />
    </FormUIContext.Provider>
  );
};

export default EditEmployee;
